/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetails.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetails>): ProgressDetails {
        let obj = Object.assign(new ProgressDetails(), model);
        ProgressDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetails>): ProgressDetails {
        if (!model) return null;
        return ProgressDetails.newInstance(<ProgressDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetails) {
        if (!obj) return;

        models.ProgressDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetails): boolean {
        Object.setPrototypeOf(obj, ProgressDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.initiated_at === "string") {
            this.initiated_at = new Date(<string><any>this.initiated_at);
        }
        if (typeof this.completed_at === "string") {
            this.completed_at = new Date(<string><any>this.completed_at);
        }
        if (this.background_job_id) {
            models.RecordIdentity.fixupPrototype(this.background_job_id);
        }
    }

    /**
     * Sync status. This is a required field.
     */
    status: models.AccountSyncProgressStatus;

    /**
     * Sync initiated time.
     */
    initiated_at: Date;

    /**
     * Sync completion time.
     */
    completed_at: Date;

    /**
     * Sync information.
     */
    message: string;

    /**
     * Background Job Id of the run
     */
    background_job_id: models.RecordIdentity;

}
